import React, { useState, useEffect } from "react";
import * as CollapseStyles from "../../../../../common-deprecated/styles/v2/toyota/custom/Collapse";
import * as CompareSpecsStyles from "../styles/CompareSpecs";
import * as Table from "../../../../../common-deprecated/components/styles/Table";
import EquipmentOrSpecPrice from "./EquipmentOrSpecPrice";
import EquipmentOrSpecValue from "./EquipmentOrSpecValue";
import ItemDescription from "./ItemDescription";
import {
    collapsibleListHasItemsToShow,
    showItemsForThisRow,
} from "../../../../../shared-logic/features/compare/utils/collapsibleListUtils";
import { ToggleIconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { type CompareV2LabelType, CompareV2Label } from "../../../utils/labels";
import CompareTable from "../../common/CompareTable";
import type { EquipmentSpecNameIdType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import { useUniqueId } from "../../../../../common-deprecated/hooks";

type CollapsibleListPropsType = {
    header: string;
    items: EquipmentSpecNameIdType[];
    onlyShowDifferences: boolean;
    showAllSpecs: boolean;
    cultureName: string;
    isMessageLabel: boolean;
    showPrices: boolean;
    carColours?: string[];
    isPdf?: boolean;
    itemNameIsKey?: boolean;
    expandTrackEvent?: (header: string) => void;
};

const CollapsibleList = (props: CollapsibleListPropsType): JSX.Element | null => {
    const uniqueId = useUniqueId();
    const { header, items, onlyShowDifferences, showAllSpecs, isMessageLabel, cultureName } = props;
    const { showPrices, carColours, isPdf, itemNameIsKey, expandTrackEvent } = props;

    const [isOpen, setIsOpen] = useState<boolean>(showAllSpecs);

    // When the showAllSpecs from the parent changes this overrides all local isOpen states
    useEffect(() => {
        setIsOpen(showAllSpecs);
    }, [showAllSpecs]);

    return collapsibleListHasItemsToShow(onlyShowDifferences, items) ? (
        <CollapseStyles.Wrapper>
            <CollapseStyles.Header
                isPdf={isPdf}
                onClick={() => {
                    setIsOpen(!isOpen);
                    if (!isOpen && expandTrackEvent) expandTrackEvent(header);
                }}
                id={`${uniqueId}-header`}
                aria-expanded={isOpen}
                aria-controls={uniqueId}
            >
                <span>{isMessageLabel ? <CompareV2Label label={header as CompareV2LabelType} /> : header}</span>
                {!isPdf && (
                    <ToggleIconWrapper isDown={isOpen}>
                        <Icon variant="chevronDown" />
                    </ToggleIconWrapper>
                )}
            </CollapseStyles.Header>
            {isOpen && (
                <CollapseStyles.Body id={uniqueId} aria-labelledby={`${uniqueId}-header`}>
                    {items.map(
                        (item: EquipmentSpecNameIdType) =>
                            showItemsForThisRow(onlyShowDifferences, !!item.allValuesAreTheSame) && (
                                <CollapseStyles.Item key={item.id}>
                                    {item.values && !!item.values.length && (
                                        <CompareTable
                                            items={item.values}
                                            columnChild={(value, index) => (
                                                // wrapper div here for pdf that can't handle the flexbox wrapper*/}
                                                <Table.InnerCol>
                                                    <CompareSpecsStyles.Label>
                                                        {itemNameIsKey ? (
                                                            <CompareV2Label label={item.name as CompareV2LabelType} />
                                                        ) : (
                                                            item.name
                                                        )}
                                                    </CompareSpecsStyles.Label>
                                                    <CompareSpecsStyles.Value isPdf={isPdf}>
                                                        <EquipmentOrSpecValue
                                                            value={value}
                                                            carColour={carColours && carColours[index]}
                                                        />
                                                        <EquipmentOrSpecPrice
                                                            index={index}
                                                            cultureName={cultureName}
                                                            price={value.price}
                                                            showPrices={showPrices}
                                                        />
                                                    </CompareSpecsStyles.Value>
                                                </Table.InnerCol>
                                            )}
                                        />
                                    )}

                                    <ItemDescription isPdf={isPdf} heightLimit={40} description={item.description} />
                                </CollapseStyles.Item>
                            ),
                    )}
                </CollapseStyles.Body>
            )}
        </CollapseStyles.Wrapper>
    ) : null;
};

export default CollapsibleList;
